import React, {useEffect, useMemo} from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import {IoIosAdd} from 'react-icons/io'
import {useDispatch, useSelector} from 'react-redux'
import {useState} from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import {BiTrash} from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import {deleteTimeSlot, getTimeSlotList} from '../../actions/time_slot'
import Loader from '../../components/Loader'
import Empty from '../../components/Empty'
import { Select } from '../../components/ModalInputs'
import { streams } from '../../assets/const'
import { getSchoolYears } from '../../actions/common'
import { minToTime } from '../../utils/MinToTime'
export default function Index() {
    const dispatch = useDispatch();
    const {list, loading, item} = useSelector(state => state.time_slot);
    const {schoolYears} = useSelector(state => state.common);

    const [selectedItem,
        setSelectedItem] = useState(null);
    const [params,
        setParams] = useState({
            school_year: 0,
            stream: 0
        });
    const [confirmation,
        setConfirmation] = useState(false);
    const [sortField, setSortField] = useState('name')
    const [sortAsc, setSortAsc] = useState(true)

    useEffect(() => {
        dispatch(getSchoolYears())
    }, [])

    const handleSort = (field) => {
        if (sortField === field) setSortAsc(v => !v)
        else { setSortField(field); setSortAsc(true) }
    }

    const sortedList = useMemo(() => {
        if (!list) return []
        return [...list].sort((a, b) => {
            const aVal = a[sortField] ?? ''
            const bVal = b[sortField] ?? ''
            if (typeof aVal === 'number' && typeof bVal === 'number')
                return sortAsc ? aVal - bVal : bVal - aVal
            return sortAsc
                ? String(aVal).localeCompare(String(bVal), 'ru')
                : String(bVal).localeCompare(String(aVal), 'ru')
        })
    }, [list, sortField, sortAsc])
    
    useEffect(() => {
        if (schoolYears.length) {
            setParams(prev => ({...prev, school_year: schoolYears?.find(el => el.actual === true)?.xp_key}))
        }
    }, [schoolYears])

    const handleGetData = () => { // Запрос на получение данных
        dispatch(getTimeSlotList({...params}));
    }
    
    useEffect(() => {
        if (item.xp_key) {
            setSelectedItem(item)
        }
    }, [item])

    const openModal = (data) => () => {
        setSelectedItem(data)
    }

    const closeModal = () => {
        setSelectedItem(null)
        dispatch({type: 'SET_TIME_SLOT_BY_ID', payload: {}})
    }

    const acceptConfirmation = () => {
        closeModal();
        dispatch(deleteTimeSlot(confirmation.id, params));
        setConfirmation(false);
    };
    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    const renderLi = (data) => {
        const {id, name, starttime, stoptime, service} = data
        return (
            <tr>
                <td onClick={openModal(data)}>{name}</td>
                <td onClick={openModal(data)}>{service ? 'Да' : 'Нет'}</td>
                <td onClick={openModal(data)}>{minToTime(starttime)}</td>
                <td onClick={openModal(data)}>{minToTime(stoptime)}</td>
                <td>
                    <i
                        className={styles.trash}
                        onClick={() => setConfirmation({id: id, name: name})}><BiTrash/></i>
                </td>
            </tr>
        )
    }

    const handleChange = (name, value) => { // Обработчик изменения параметров поиска
        setParams({
            ...params,
            [name]: value
        });
    }

    return (
        <div
            className={styles.wrapper}
            style={{
            width: '100%',
            margin: '0 auto'
        }}>

             

            {confirmation && (<Confirmation
                top="30px"
                left="40px"
                title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                acceptConfirmation={() => acceptConfirmation(confirmation?.id)}
                rejectConfirmation={rejectConfirmation}/>)}

            {selectedItem && <Modal
                setMode={setSelectedItem}
                closeModal={closeModal}
                data={selectedItem}
                schoolYears={schoolYears}
                streams={streams}
                height={'430px'}
                params={params}
                addMode={selectedItem == 'add'}/>}

            <h1>Временные слоты</h1>

            <div className={styles.container}>
                <div className={styles.inputsRow}>
                    <div className={styles.container_select}>
                        <Select
                            value={params.school_year}
                            name='school_year'
                            label='Год поступления'
                            onChange={(e) => handleChange(e.target.name, Number(e.target.value))}>
                            {schoolYears?.map(el => <option value={el.xp_key}>{el.name}</option>)}</Select>
                        <Select
                            name='stream'
                            label='Набор'
                            value={params.stream}
                            onChange={(e) => handleChange(e.target.name, Number(e.target.value))}>
                            {streams
                                .map(el => <option value={el.value}>{el.name}</option>)}</Select>
                    </div>

                    <Button className={styles.button} onClick={() => handleGetData()}>Обновить</Button>
                </div>
            </div>

            {loading && <Loader/>}

            {!loading && !list?.length
                    ? <Empty/>
                    : <Table className={styles.tables}>
                        <thead>
                            <tr>
                                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>Название</th>
                                <th>Служебный слот</th>
                                <th onClick={() => handleSort('starttime')} style={{ cursor: 'pointer' }}>Начало</th>
                                <th onClick={() => handleSort('stoptime')} style={{ cursor: 'pointer' }}>Конец</th>
                                <th width={'1.5rem'}>Удалить</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedList.map(renderLi)}
                        </tbody>
                    </Table>}

            <div
                style={{
                display: 'flex',
                flexDirection: "row"
            }}>
                <Button
                    style={{
                    padding: '.5rem 1.5rem',
                    margin: '12px'
                }}
                    onClick={openModal('add')}>
                    <IoIosAdd size={30}/>
                    Создать слот
                </Button>
            </div>
        </div>
    )
}
